




























































































































import { defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import { SfIcon, SfBadge } from '~/components/StorefrontUi';
import HTMLContent from '~/components/HTMLContent.vue';
import type { RemovableFilterInterface } from '~/modules/catalog/category/components/filters/useFilters';
import { FilterTypeEnum } from '~/modules/catalog/category/config/config';

export default defineComponent({
  components: {
    HTMLContent,
    SfBadge,
    SfIcon,
  },
  props: {
    removableFilters: {
      type: Array as PropType<RemovableFilterInterface[]>,
      default: () => [],
    },
    searchFilter: {
      type: Object,
      default: () => {},
    },
    newFilter: {
      type: Object,
      default: () => {},
    },
  },
  setup(_, { emit }) {
    const {
      app: { i18n },
    } = useContext();

    const getLabel = (filter: RemovableFilterInterface) => {
      if (filter.type === FilterTypeEnum.YES_NO) {
        const yesNo = filter.label === '1' ? i18n.t('Yes') : i18n.t('No');
        return `${filter.name}: ${yesNo}`;
      }

      if (filter.type === FilterTypeEnum.RANGE_SLIDER) {
        return `${i18n.t(filter.name)}: ${filter.label}`;
      }

      return filter.label;
    };

    const doClearFilters = () => {
      emit('clearFilters');
    };

    return {
      doClearFilters,
      getLabel,
    };
  },
});
